import { GlobalController } from 'src/shared/global/GlobalController'
import ConcessionDashboard from './ConcessionDashboard.vue'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [

  {
    path: ':link',
    name: 'concessionDashboard',
    component: ConcessionDashboard,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
